import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import MemberPulse from "@/pages/MemberPulse";
import AuthGate from "@/components/AuthGate";

export const Route = createFileRoute("/pulse")({
  head: () => seoHead("/pulse"),
  component: () => (
    <AuthGate><MemberPulse /></AuthGate>
  ),
});
